import { useEffect, useState, useCallback, useMemo } from "react";
import { useRouter } from "next/router";
import SearchPageMetaTags from "@/components/MetaTags/SearchPageMetaTags";
import SearchResult from "@/components/SearchResult";
import DropdownSelect from "@/components/DropdownSelect";
import { useBreadcrumbs } from "@/hooks";
import { searchSort, searchTvShowSort } from "@/lib/sorts";
import contentsStyles from "@/styles/Contents.module.scss";
import routes from "@/lib/routes";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function SearchDetail() {
  var _router$query, _router$query2;
  const router = useRouter();
  const path = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.path;
  const searchQuery = router === null || router === void 0 || (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.q;
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const sorts = useMemo(() => {
    if (path === "valueplan") {
      return searchTvShowSort;
    } else {
      return searchSort;
    }
  }, [path]);
  const {
    0: sort,
    1: setSort
  } = useState(sorts[0].value);
  const searchResultTitles = useMemo(() => {
    return {
      valueplan: config.valuePlan.text,
      channel: "月額商品",
      store: "単品商品",
      live: "ライブ"
    };
  }, []);
  const handleSelect = useCallback(selectedSort => {
    setSort(selectedSort.value);
  }, []);
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "検索結果",
      href: routes.search(searchQuery)
    }, {
      text: searchResultTitles[path]
    }]);
  }, [path, searchQuery]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SearchPageMetaTags, {
      keyword: searchQuery,
      mode: path
    }), /*#__PURE__*/_jsxs("div", {
      className: contentsStyles.container,
      children: [/*#__PURE__*/_jsx("header", {
        children: /*#__PURE__*/_jsxs("h1", {
          children: [searchResultTitles[path], " \"", searchQuery, "\"\u306E\u691C\u7D22\u7D50\u679C"]
        })
      }), /*#__PURE__*/_jsxs("nav", {
        className: contentsStyles.withSort,
        children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(DropdownSelect, {
          right: true,
          options: sorts,
          onSelect: handleSelect,
          className: "sort"
        })]
      }), /*#__PURE__*/_jsx(SearchResult, {
        mode: path,
        searchQuery: searchQuery,
        sort: sort
      })]
    })]
  });
}